import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import NewsList from '@src/pc/index/layout/NewsList';
import MediaNews from '@src/pc/index/layout/MediaNews';
import Banner from '@src/pc/index/layout/components/Banner';
import Double from '@src/pc/index/layout/Double';
import Grid from '@src/pc/index/layout/Grid';
import LongImages from '@src/pc/index/layout/LongImages';
import ImageSwiper from '@src/pc/index/layout/ImageSwiper';
import Support from '@src/pc/index/layout/Support';
import NewsUL from '@src/pc/index/layout/NewsUL';
import VideoList from '@src/pc/index/layout/VideoList';
import Luntan from '@src/pc/index/layout/Luntan';
import TabContent from '@src/pc/index/layout/TabContent';
import ImageGallery from '@src/pc/index/layout/ImageGallery';
import YiCheng from '@src/pc/index/layout/YiCheng';
import Header from '@src/pc/index/layout/Header';
import Footer from '@src/pc/index/layout/Footer';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';
import { ChipMap } from '../chipMap';
import { Comment } from '@ifeng-fe/three_terminal/es/pc/comment';
import Ad from '@ifeng-fe/ui_pc_ad';

const Layout = ({ content }) => {

    const GetContent = (id) => {
        switch (id) {
            case 'box1': {
                return (
                    <div>
                        <div className={styles.box1} key="box1" id="box1">
                            <Chip key="NewsList" {...ChipMap.NewsList} content={content.NewsList}>
                                <NewsList />
                            </Chip>
                            <MediaNews content={content} />
                        </div>
                        <img src={require('../assets/support.jpg')} alt="" style={{ marginTop: '20px' }} />
                    </div>
                );
            }
            case 'box2': {
                return (
                    <div className={styles.box2} key="box2" id="box2">
                        <Chip key="Banner3" {...ChipMap.Banner3}>
                            <Banner type="large" title={content.Banner3} />
                        </Chip>
                        <Chip key="Kaimu1" {...ChipMap.Kaimu1} content={content.Kaimu1}>
                            <TabContent />
                        </Chip>
                    </div>
                );
            }
            case 'box3': {
                return (
                    <div className={styles.box3} key="box3" id="box3">
                        <Chip key="Banner4" {...ChipMap.Banner4}>
                            <Banner type="large" title={content.Banner4} />
                        </Chip>
                        <Chip key="Kaimu2" {...ChipMap.Kaimu2} content={content.Kaimu2}>
                            <TabContent />
                        </Chip>
                    </div>
                );
            }
            case 'box4': {
                return (
                    <div className={styles.box4} key="box4" id="box4">
                        <Chip key="Banner5" {...ChipMap.Banner5}>
                            <Banner type="large" title={content.Banner5} />
                        </Chip>
                        <Chip key="Kaimu3" {...ChipMap.Kaimu3} content={content.Kaimu3}>
                            <TabContent />
                        </Chip>
                    </div>
                );
            }
            case 'box5': {
                return (
                    <div className={styles.box5} key="box5" id="box5">
                        <Chip key="Banner6" {...ChipMap.Banner6}>
                            <Banner type="large" title={content.Banner6} />
                        </Chip>
                        <Chip key="Luntan" {...ChipMap.Luntan} content={content.Luntan}>
                            <Luntan />
                        </Chip>
                    </div>
                );
            }
            case 'box6': {
                return (
                    <div className={styles.box6} key="box6" id="box6">
                        <Chip key="Banner7" {...ChipMap.Banner7}>
                            <Banner type="large" title={content.Banner7} />
                        </Chip>
                        <Chip key="Double" {...ChipMap.Double} content={content.Double}>
                            <Double />
                        </Chip>
                    </div>
                );
            }
            case 'box7': {
                return (
                    <div className={styles.box7} key="box7" id="box7">
                        <Chip key="Banner8" {...ChipMap.Banner8}>
                            <Banner type="large" title={content.Banner8} />
                        </Chip>
                        <Chip key="Grid1" {...ChipMap.Grid1} content={content.Grid1}>
                            <Grid />
                        </Chip>
                    </div>
                );
            }
            case 'box8': {
                return (
                    <div className={styles.box8} key="box8" id="box8">
                        <Chip key="Banner9" {...ChipMap.Banner9}>
                            <Banner type="large" title={content.Banner9} />
                        </Chip>
                        <Chip key="Grid1" {...ChipMap.Grid2} content={content.Grid2}>
                            <Grid />
                        </Chip>
                    </div>
                );
            }
            case 'box9': {
                return (
                    <div className={styles.box9} key="box9" id="box9">
                        <Chip key="Banner10" {...ChipMap.Banner10}>
                            <Banner type="large" title={content.Banner10} />
                        </Chip>
                        <Chip key="Grid3" {...ChipMap.Grid3} content={content.Grid3}>
                            <Grid />
                        </Chip>
                    </div>
                );
            }
            case 'box10': {
                return (
                    <div className={styles.box10} key="box10" id="box10">
                        <Chip key="Banner11" {...ChipMap.Banner11}>
                            <Banner type="large" title={content.Banner11} />
                        </Chip>
                        <Chip key="Grid3" {...ChipMap.Grid4} content={content.Grid4}>
                            <Grid />
                        </Chip>
                    </div>
                );
            }
            case 'box11': {
                return (
                    <div className={styles.box11} key="box11" id="box11">
                        <Chip key="Banner12" {...ChipMap.Banner12}>
                            <Banner type="large" title={content.Banner12} />
                        </Chip>
                        <Chip key="Grid5" {...ChipMap.Grid5} content={content.Grid5}>
                            <Grid />
                        </Chip>
                    </div>
                );
            }
            case 'box12': {
                return (
                    <div className={styles.box12} key="box12" id="box12">
                        <Chip key="Banner13" {...ChipMap.Banner13}>
                            <Banner type="large" title={content.Banner13} />
                        </Chip>
                        <Chip key="Double2" {...ChipMap.Double2} content={content.Double2}>
                            <Double />
                        </Chip>
                    </div>
                );
            }
            case 'box13': {
                return (
                    <div className={styles.box13} key="box13" id="box13">
                        <Chip key="Banner14" {...ChipMap.Banner14}>
                            <Banner type="large" title={content.Banner14} />
                        </Chip>
                        <Chip key="TuPianCeHua" {...ChipMap.TuPianCeHua} content={content.TuPianCeHua}>
                            <LongImages />
                        </Chip>
                    </div>
                );
            }
            case 'box14': {
                return (
                    <div className={styles.box14} key="box14" id="box14">
                        <Chip key="Banner15" {...ChipMap.Banner15}>
                            <Banner type="large" title={content.Banner15} />
                        </Chip>
                        <Chip key="LargeVideoList" {...ChipMap.LargeVideoList} content={content.LargeVideoList}>
                            <VideoList />
                        </Chip>
                    </div>
                );
            }
            case 'box15': {
                return (
                    <div className={styles.box15} key="box15" id="box15">
                        <Chip key="Banner16" {...ChipMap.Banner16}>
                            <Banner type="large" title={content.Banner16} />
                        </Chip>
                        <Chip key="Jingcaishunjian" {...ChipMap.Jingcaishunjian} content={content.Jingcaishunjian}>
                            <ImageGallery />
                        </Chip>
                    </div>
                );
            }
            case 'box16': {
                return (
                    <div className={styles.box16} key="box16" id="box16">
                        <Chip key="Banner17" {...ChipMap.Banner17}>
                            <Banner type="large" title={content.Banner17} />
                        </Chip>
                        <Chip key="GaoQindDaTu" {...ChipMap.GaoQingDaTu} content={content.GaoQingDaTu}>
                            <ImageSwiper />
                        </Chip>
                    </div>
                );
            }
            case 'box17': {
                return (
                    <div className={styles.box17} key="box17" id="box17">
                        <Chip key="Banner18" {...ChipMap.Banner18}>
                            <Banner type="large" title={content.Banner18} />
                        </Chip>
                        <Chip key="Yicheng" {...ChipMap.Yicheng} content={content.Yicheng}>
                            <YiCheng />
                        </Chip>
                    </div>
                );
            }
            case 'box18': {
                return (
                    <div className={styles.box18} key="box18" id="box18">
                        <Chip key="Banner19" {...ChipMap.Banner19}>
                            <Banner type="large" title={content.Banner19} />
                        </Chip>
                        <div className={styles.flex}>
                            <div className={styles.left}>
                                <Chip key="NewsULTitle1" {...ChipMap.NewsULTitle1}>
                                    <Banner type="url" title={content.NewsULTitle1.title} url={content.NewsULTitle1.url} />
                                </Chip>
                                <Chip key="NewsUL1" {...ChipMap.NewsUL1} content={content.NewsUL1}>
                                    <NewsUL />
                                </Chip>

                                <Chip key="NewsULTitle2" {...ChipMap.NewsULTitle2}>
                                    <Banner type="url" title={content.NewsULTitle2.title} url={content.NewsULTitle2.url} />
                                </Chip>
                                <Chip key="NewsUL2" {...ChipMap.NewsUL2} content={content.NewsUL2}>
                                    <NewsUL />
                                </Chip>

                                <Chip key="NewsULTitle3" {...ChipMap.NewsULTitle3}>
                                    <Banner type="url" title={content.NewsULTitle3.title} url={content.NewsULTitle3.url} />
                                </Chip>
                                <Chip key="NewsUL3" {...ChipMap.NewsUL3} content={content.NewsUL3}>
                                    <NewsUL />
                                </Chip>

                            </div>
                            <div className={styles.right}>
                                <div className={styles.block}>
                                    <Chip key="Support" {...ChipMap.Support} content={content.Support}>
                                        <Support />
                                    </Chip>
                                </div>
                                <div className={styles.block}>
                                    <div className={styles.title} style={{ borderBottom: 'solid 1px #ddd' }}>版权声明</div>
                                    <div className={styles.title}>
                                        凤凰网 <a href="https://finance.ifeng.com/" target="_blank">财经</a> 中心出品，欢迎收藏。
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
            case 'box19': {
                return (
                    <div className={styles.box19} key="box19" id="box19">
                        <Chip key="Banner20" {...ChipMap.Banner20}>
                            <Banner type="large" title={content.Banner20} />
                        </Chip>
                        <Chip key="Luntan2" {...ChipMap.Luntan2} content={content.Luntan2}>
                            <Luntan />
                        </Chip>
                    </div>
                );
            }
            case 'box20': {
                return (
                    <div className={styles.box20} key="box20" id="box20">
                        <Chip key="Banner21" {...ChipMap.Banner21}>
                            <Banner type="large" title={content.Banner21} />
                        </Chip>
                        <Chip key="Luntan3" {...ChipMap.Luntan3} content={content.Luntan3}>
                            <Luntan />
                        </Chip>
                    </div>
                );
            }
            case 'box21': {
                return (
                    <div className={styles.box21} key="box21" id="box21">
                        <Chip key="Banner22" {...ChipMap.Banner22}>
                            <Banner type="large" title={content.Banner22} />
                        </Chip>
                        <Chip key="SpecialSupport" {...ChipMap.SpecialSupport} content={content.SpecialSupport}>
                            <div dangerouslySetInnerHTML={{ __html: content.SpecialSupport }} />
                        </Chip>
                    </div>
                );
            }
            case 'ad1': {
                return (
                    <div className={styles.ad1} key="ad1" id="ad1">
                        <Ad key="ad1" content={{ desc: ChipMap.ad1, ...content.ad1 }} />
                    </div>
                );
            }
        }
    };

    const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';
    
    return (
        <div className={styles.layout}>
            <Chip key="Layout" {...ChipMap.Layout} content={content['Layout']}>
                <div />
            </Chip>
            <Header searchData={content.Search} />
            <div className={styles.mainWp}>
                <div className={styles.mainImage}>
                    <Chip key="mainImage" {...ChipMap.mainImage}>
                        <img className={styles.banner} src={content.mainImage} alt="主图" />
                    </Chip>
                </div>
                <div className={styles.main}>
                    {
                        content.Layout.map((item) => {
                            return item.isShow ? GetContent(item.id) : null;
                        })
                    }
                    <div className={styles.commentWp}>
                        <Comment
                            articleInfo={{
                                noAd: true,
                                // 文章单页的页面地址 commentUrl
                                docUrl: 'https://finance.ifeng.com/loc/special/2022xjfh',
                                // 文章的标题
                                docTitle: '2022夏季财经峰会',
                                // 文章评论的skey，这个是在后端生成好后给到前端的，个性化页面没有skey的话，可以为空
                                skey: '',
                                // 兼容以后的专题评论
                                speUrl: '',
                                // 文章pc的页面地址
                                pcUrl: '',
                                // 获取评论内容接口
                                cmtNumUrl: `https://${ commentDomain }/get.php`,
                                // 评论内容字数长度
                                cmtLength: 1000,
                                // 提交评论内容接口
                                cmtPostUrl: `https://${ commentDomain }/post.php`,
                                // 最热评论数量
                                hotLimit: 2,
                                // 推荐评论接口
                                cmtVoteUrl: `https://${ commentDomain }/vote.php`,
                                // 现实回复的楼层
                                replyLimit: 3,
                                // 举报提交接口
                                jubUrl: `https://${ commentDomain }/report`,
                                // 举报次数，便于每次回调函数名不同
                                jubNum: 0,
                                // 是否是评论详情页面
                                isComment: false,
                                // docUrl: "ucms_86YOkEdIiC1"
                            }}
                        />
                    </div>
                </div>

                <Footer />
                <ChipEdit transform={chipDataTransform} />
            </div>
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
